import { v4 as uuidv4 } from "uuid";

export const namespaced = true;

export const state = {
    works: [],
    loading: false,
}

export const mutations = {
    FETCH_WORKS(state, works) {
        state.works = works;
    },

    REMOVE_WORK() { },
}

export const actions = {

    async fetch({ commit, state, dispatch }) {
        try {
            const res = (await axios.get(`/api/admin/additional_works`)).data;
            commit('FETCH_WORKS', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },


    async remove({ commit, dispatch }, work_id) {
        try {
            const res = (await axios.delete(`/api/admin/additional_works/${work_id}`)).data;
            commit('REMOVE_WORK', res.data);
            dispatch('fetch');
            const notification = {
                type: 'success',
                message: 'Удаление прошло успешно'
            }
            dispatch('notification/add', notification, { root: true })
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },

    async save() {
        try {
            const res = (await axios.get(`/api/admin/types`, {
                params: {
                    model: state.currentModel,
                    group_id: state.currentGroupId || null,
                    page: state.page,
                    per_page: state.per_page
                }
            })).data;
            commit('FETCH_TYPES', res.data);
            commit('FETCH_META', res.meta);
            return res.data;
        } catch (error) {
            const notification = {
                type: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    }







}
